<template>
  <div class="pcard--task d-flex  flex-wrap mb-2 item">
    <div v-if="unlink" style="min-width: 30px;" class="pr-1 pl-1 pt-1">
      <i class="bx bx-trash text-danger" @click="unlinkEvent"></i>
    </div>

    <div class="pr-1 pt-1" @click="click" v-if="hideIcon">
      <i :class="iconColor" v-b-tooltip.hover :title="iconTitle" class="iconoir-activity font-size-22"></i>
    </div>
    <div class="pr-1 pt-1" :class="isItDefinition ? 'text-muted' : ''" @click="click">
      <b>{{ risk.name | translate }}</b>
    </div>
  </div>
</template>

<script>
export default {
  props: ["risk", "unlink", "isItDefinition", "hideIcon"],

  computed: {
    iconTitle() {
      if (this.isItDefinition) {
      } else {
        if (this.risk.status == "ACTIVE") {
          return this.$t("risk.status.active");
        } else {
          return this.$t("risk.status.inactive");
        }
      }
    },
    icon() {
      if (this.isItDefinition) {
        return "text-muted";
      } else {
        if (this.risk.status == "ACTIVE") {
          return "text-primary";
        } else {
          return "text-muted";
        }
      }
    },
    iconColor() {
      if (this.isItDefinition) {
        return "text-muted";
      } else {
        if (this.risk.status == "ACTIVE") {
          return "text-primary";
        } else {
          return "text-muted";
        }
      }
    },
  },
  methods: {
    unlinkEvent() {
      this.$emit("unlinked", this.risk);
    },

    click() {
      this.$emit("click", this.risk);
    },
  },
};
</script>

<style scoped>
.item {
  height: auto !important;
  padding-bottom: 5px !important;
}
</style>
